export const DepartureAirportGroupings = 'departure-airport-groupings';
export const DestinationAirportGroupings = 'destination-airport-groupings';
